{
  "welcome": "Welcome",
  "subHeader": "Enter your login details below",
  "email": "Email",
  "password": "Password",
  "forgot": "Forgot your password?",
  "noAccount": "Do not have an account?",
  "getStarted": "Get started",
  "fieldRequired": "Field is required",
  "valueShouldBeAnEmail": "Invalid value for the filed, it should be a valid E-mail",
  "log_in": "Log In"
}
